import React from "react";
import { func } from "prop-types";
import Image from "../Image";
import Block from "../Block";
import Link from "../Link";
import Paragraph from "../Paragraph";
import NavbarItemLink from "../Navbar/Link";
import pureProps, { deepMergeProps } from "../utils/pureProps";
import { sxProps } from "../props/sx";
import { spacingProps } from "../props/spacing";
import { utilityProps } from "../props/utility";
import { sizingProps } from "../props/sizing";

const ItemLink = ({ spacing = { ...spacingProps }, ...props }) => {
	return (
		<Block>
			<NavbarItemLink spacing={deepMergeProps({ pl: 1 }, pureProps(spacing))} {...props} />
		</Block>
	);
};

ItemLink.propTypes = {
	...Link.propTypes,
	onClick: func,
};

const ItemDescription = ({ sx = { ...sxProps }, spacing = { ...spacingProps }, ...props }) => {
	return (
		<Block
			sx={deepMergeProps({ fontColor: "black--46", fontSize: "s" }, pureProps(sx))}
			spacing={deepMergeProps({ mt: 1, pl: 1 }, pureProps(spacing))}
			{...props}
		/>
	);
};

ItemDescription.propTypes = {
	...Paragraph.propTypes,
};

export const ItemImage = ({
	utility = { ...utilityProps },
	spacing = { ...spacingProps },
	sizing = { ...sizingProps },
	className = "",
	src,
	...props
}) => {
	return (
		<Image
			utility={utility}
			spacing={deepMergeProps({ pl: 1 }, pureProps(spacing))}
			sizing={sizing}
			src={src}
			className={className}
			{...props}
		/>
	);
};

ItemImage.propTypes = {
	...Image.propTypes,
};

const MegaMenuItem = ({ ...props }) => <Block spacing={{ my: 4 }} {...props} />;

MegaMenuItem.Link = ItemLink;
MegaMenuItem.Description = ItemDescription;
MegaMenuItem.Image = ItemImage;

export default MegaMenuItem;
